import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { SeoTags } from "../../components";
import { PrivacyPolicy } from "../../components/info/PrivacyPolicyComponent";
import { setShowSearch } from "../../store/appConfigsSlice";

const PrivacyPolicePage = () => {
	const dispatch = useDispatch();

	useEffect (() => {
		dispatch(setShowSearch(false))
	}, []);

	return (
		<>
			<SeoTags pageKey="privacyPolicyPage" />
			<PrivacyPolicy />
		</>
	);
};

export default PrivacyPolicePage;